import React from "react";
import { DownloadFile } from '../others/DownloadFile';

export const DownloadAllFiles = ({ data, rowData = null, companyInfo = {} }) => {
    const item = data?.trigger?.[0]?.bodyData;

    return (
        <DownloadFile
            path={item?.path}
            bucket={item?.bucket}
            idFlow={item?.id_flow}
            data={data}
            rowData={rowData}
            companyInfo={companyInfo}
        />
    );
}
